import React from 'react';
import {Route, Routes, Outlet} from 'react-router-dom'
import OverviewPage from '@/app/modules/analytics/overview/OverviewPage';
import DevicePage from '@/app/modules/analytics/devices/DevicesPage';
import PageReportPage from '@/app/modules/analytics/pages-report/PagesReportPage';
import ReportPage from '@/app/modules/analytics/reports/ReportsPage';
import {DateRangeProvider} from '@/app/modules/analytics/hooks/useDateRange'
import {WebsiteProvider} from '@/app/modules/analytics/hooks/useWebsite'

const AnalyticsPage = () => (
  <WebsiteProvider websiteId="691d9f2e426eb5d7cc086891">
     <DateRangeProvider
      defaultRange="week"
      minDate={new Date('2012-01-01')}
      maxDate={new Date()}
    >
      <Routes>
        <Route element={<Outlet />}>
          <Route path='/overview' element={<OverviewPage />} />
          <Route path='/devices' element={<DevicePage />} />
          <Route path='/pages' element={<PageReportPage />} />
          <Route path='/reports' element={<ReportPage />} />
        </Route>
      </Routes>
    </DateRangeProvider>
  </WebsiteProvider>
)

export default AnalyticsPage
